<script>
import { Pie, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: ["chartData", "chartOptions"],
  data() {
    return {
      //   chartData: {
      //     labels: ["January", "February"],
      //     datasets: [
      //       {
      //         label: "Data One",
      //         backgroundColor: "#f87979",
      //         data: [40, 20]
      //       }
      //     ]
      //   },
      //   chartOptions: {
      //     responsive: true,
      //     maintainAspectRatio: false
      //   }
      // color: "",
      // text: ""
      // chartData: [10, 20, 30]
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
    // this.renderChart(
    //   {
    //     labels: [
    //       "January",
    //       "February",
    //       "March",
    //       "April",
    //       "May",
    //       "June",
    //       "July"
    //     ],
    //     datasets: [
    //       {
    //         label: "Data One",
    //         backgroundColor: "#f87979",
    //         data: this.chartData
    //       }
    //     ]
    //   },
    //   { responsive: true, maintainAspectRatio: false }
    // );
  }
};
</script>

